import { makeStyles, createStyles } from "@material-ui/styles"

const useStyles = makeStyles(theme =>
  createStyles({
    grayLabel: {
      color: "#9A9A9A",
    },
    dialogPaper: {
      width: "100%",
    },
    fakeinput: {
      // will be used to make box around chips & input for email addresses      }
    },
    buttons: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      width: "85%",
      marginTop: "40px",
    },
  })
)

export default useStyles
